import React from 'react';
import { useUser } from 'packages/smart-home-support/hooks';
import { isInTestGroup } from 'packages/smart-home-support/utils';
import { MaybeUser } from './../pages/auth/models';

type ShowHideProps = {
    testGroupKey: string;
    children: any;
};

type TestGroupFeatureProps = ShowHideProps & {
    show: boolean;
};

const TestGroupFeature: React.FC<TestGroupFeatureProps> = ({ children, testGroupKey, show }) => {
    const user: MaybeUser = useUser();
    const isTestGroup: boolean = isInTestGroup(user, testGroupKey);

    if (show) {
        return isTestGroup ? (<>{children}</>) : null;
    }

    return isTestGroup ? null : (<>{children}</>);
};

export const ShowForTestGroup: React.FC<ShowHideProps> = props => (<TestGroupFeature { ...props } show= { true } />);
export const HideForTestGroup: React.FC<ShowHideProps> = props => (<TestGroupFeature { ...props } show= { false } />);



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/TestGroupFeature.tsx